import { Eye, MoreHorizontal, RefreshCcw, Trash2 } from 'lucide-react';

import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import {
    SidebarGroup,
    SidebarGroupLabel,
    SidebarMenu,
    SidebarMenuAction,
    SidebarMenuButton,
    SidebarMenuItem,
    useSidebar,
} from '@/components/ui/sidebar';
import { useNavigate } from 'react-router-dom';

export function NavIntegrations({
    integrations,
}: {
    integrations: {
        name: string;
        url?: string;
        isActive?: boolean;
        logoSrc?: string;
        type: string;
    }[];
}) {
    const { isMobile } = useSidebar();
    const navigate = useNavigate();
    return (
        <SidebarGroup className='group-data-[collapsible=icon]:hidden'>
            <SidebarGroupLabel>Integrations</SidebarGroupLabel>
            <SidebarMenu>
                {integrations.map(item => (
                    <SidebarMenuItem key={item.name}>
                        <SidebarMenuButton asChild>
                            <div onClick={() => item.url && navigate(item.url)} className='highlight-menu-item'>
                                <div className='flex items-center gap-2'>
                                    {item.logoSrc && <img src={item.logoSrc} alt={item.name} className='h-4 w-4' />}
                                    <span>{item.name}</span>
                                    <div
                                        className={`ml-auto h-1.5 w-1.5 rounded-full ${
                                            item.isActive ? 'bg-green-500' : 'bg-red-500'
                                        }`}
                                        title={item.isActive ? 'Active' : 'Inactive'}
                                    />
                                </div>
                            </div>
                        </SidebarMenuButton>
                        <DropdownMenu>
                            <DropdownMenuTrigger asChild>
                                <SidebarMenuAction showOnHover className='cursor-pointer'>
                                    <MoreHorizontal />
                                    <span className='sr-only'>More</span>
                                </SidebarMenuAction>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent
                                className='w-48 rounded-lg bg-slate-800/30 backdrop-blur-md'
                                side={isMobile ? 'bottom' : 'right'}
                                align={isMobile ? 'end' : 'start'}
                            >
                                <DropdownMenuItem className='highlight-menu-item'>
                                    <Eye className='text-muted-foreground' />
                                    <span>View Integration</span>
                                </DropdownMenuItem>
                                <DropdownMenuItem className='highlight-menu-item'>
                                    <RefreshCcw className='text-muted-foreground' />
                                    <span>Refresh Data</span>
                                </DropdownMenuItem>
                                <DropdownMenuSeparator />
                                <DropdownMenuItem className='highlight-menu-item'>
                                    <Trash2 className='text-muted-foreground' />
                                    <span>Delete Integration</span>
                                </DropdownMenuItem>
                            </DropdownMenuContent>
                        </DropdownMenu>
                    </SidebarMenuItem>
                ))}
            </SidebarMenu>
        </SidebarGroup>
    );
}
